/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_Center_Justify_Center_PosInputs */



/**
* | output |
* | --- |
* | "Center Justify / Center Position" |
*
* @param {Align_Center_Center_Justify_Center_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_center_justify_center_pos = /** @type {((inputs?: Align_Center_Center_Justify_Center_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_Center_Justify_Center_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Centree / Position Centree")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zentriert ausrichten / Zentrierte Position")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allineamento al centro / Posizione centrale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центрирование по выравниванию / Центрирование по позиции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificar al centro / Posición centrada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("居中对齐 / 居中位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央揃え / 中央位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र में रखें / केंद्र में रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centralizar Justificar / Posicionamento Centralizado")
	return /** @type {LocalizedString} */ ("Center Justify / Center Position")
});